import classNames from "classnames";
import { useBookingNotes } from "PFCore/hooks/queries/bookings/notes/use_booking_notes";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import React, { useMemo, useState } from "react";

import BookingHistory from "../booking_history";
import BookingHistoryButton from "../booking_history/booking_history_button";
import BookingNotes from "../booking_notes";
import BookingNotesButton from "../booking_notes/booking_notes_button";
import css from "./bottom_cards.module.scss";

const BottomCards = ({ booking }) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const [selected, setSelected] = useState<string | null>();
  const { getBookingCategory } = useBookingCategories();
  const isBookingReadonly = getBookingCategory(booking.booking_category_id)?.readonly;

  const { data: notesData } = useBookingNotes(booking?.id, 1, 0);

  const handleClick = (cardName) => {
    if (expanded) {
      if (selected === cardName) {
        setSelected(null);
        setExpanded(false);
      } else {
        setSelected(cardName);
      }
    } else {
      setExpanded(true);
      setSelected(cardName);
    }
  };

  const cards = useMemo(
    () => [
      {
        id: "notes",
        Component: (props) => <BookingNotes readonly={isBookingReadonly} {...props} />,
        ButtonComponent: BookingNotesButton,
        data: notesData
      },
      {
        id: "history",
        Component: BookingHistory,
        ButtonComponent: BookingHistoryButton,
        data: null
      }
    ],
    [notesData]
  );

  const renderComponent = (props) => {
    const Component = cards.find(({ id }) => id === selected)?.Component;
    if (Component) {
      return <Component {...props} />;
    } else {
      return null;
    }
  };

  const containerId = `booking-${selected}-container-${booking.id}`;

  return (
    <div className={css.spaceHolder}>
      <div className={classNames(css.root, { [css.notExpanded]: !expanded })}>
        {cards.map(({ ButtonComponent, id, data }) => (
          <ButtonComponent
            key={id}
            count={data?.meta?.total || 0}
            expanded={expanded}
            selected={selected === id}
            onClick={() => handleClick(id)}
          />
        ))}

        <div id={containerId} className={css.container}>
          {renderComponent({ bookingId: booking.id, containerId })}
        </div>
      </div>
    </div>
  );
};

export default BottomCards;
